import { useNewFeaturesStore } from '@/store';
import {Directive} from "vue";

const NewFeatureBadge: Directive = {
  beforeMount(el, binding) {
    const featureStore = useNewFeaturesStore()
    if (featureStore.isNew(binding.value)) {
      const badge = document.createElement('span')
      badge.innerText = "New!"
      badge.classList.add('new-badge')
      el.appendChild(badge)
    }
  }
}

export default NewFeatureBadge